// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__y6ez8","createdSearch":"index_createdSearch__eqLjR","custom_table":"index_custom_table__899m+"};